export default __webpack_public_path__ + "static/komposisjon-eksempel1-95df0f3a80e6a92910b2fea21f0f0d66.png";